import {
  AiIndexingRetryLaneEnum,
  AiIndexingStatusEnum,
  DocumentationFilterInputObject,
} from 'graphql-common';

// The predicate values are the uppercase ENUM NAMEs even though the filters
// type as FilterIntInputObject: their predicates take Strings on the wire.
// Sourced from the generated enums rather than literals so a backend rename
// fails the build.

// The parked banner's set. The lane is what "nothing will retry this"
// actually means — the FAILED status also holds documents still being
// retried, and a document parked while STALE never reports FAILED at all.
export const PARKED_FILTERS: DocumentationFilterInputObject[] = [
  {
    aiIndexingRetryLane: { predicate: { eq: AiIndexingRetryLaneEnum.Parked } },
  },
];

// The "Not indexable" count's set — processed but yielding no searchable
// text (unsupported file type, nothing extractable). Not a failure and
// nothing will retry it, so it has no `aiIndexingRetryLane` counterpart.
export const SKIPPED_FILTERS: DocumentationFilterInputObject[] = [
  { aiIndexingStatus: { predicate: { eq: AiIndexingStatusEnum.Skipped } } },
];

// The "Failed" count's set — broader than PARKED_FILTERS: it also includes
// documents automatic retries haven't given up on yet.
export const FAILED_FILTERS: DocumentationFilterInputObject[] = [
  { aiIndexingStatus: { predicate: { eq: AiIndexingStatusEnum.Failed } } },
];
